import React, {useEffect, useState} from 'react';
import WelcomeView from './WelcomeView';
import TestProgressView from './TestProgressView';
import testService from "../../../services/test.service";
import lessonService from "../../../services/lesson.service";
import {useSetRecoilState} from "recoil";
import {
    durationState, errorCodeState, testStatusState, requiredTimeState, requiredTimeSubmitState, valueSlideState
} from "../../../states/states";
import {
    currentTestState, lessonTypeState, numberOfQuestionState, numberOfRootQuestionState, testTypeState,
    currentQuestionIndexState, answersState, nextAbleQuestionsState
} from "../../../states/test_progress_states"
import Loading from "../../helper/Loading";
import withUrlParams from "../../HOC/withUrlParams";
import withAuth from "../../HOC/withAuth";
import withErrorMessage from "../../HOC/withErrorMessage";
import {useRecoilState} from "recoil";
import {testStatusNames} from "../../../config/constants";
import i18n from "i18next";
import CustomSweetAlert from "../../helper/CustomSweetAlert";
import logService from "../../../services/log.service";
import deleteDraftAnswer from "../../../helpers/deleteDraftAnswer";

const TestLayout = (props) => {
    const {accessToken, getTokenErr, uuid, testCode, lessonCode, handleError, answersStorageKey, isOnline} = props;
    const [testInfo, setTestInfo] = useState({});
    const [testStatus, setTestStatus] = useRecoilState(testStatusState);
    const setErrorCode = useSetRecoilState(errorCodeState);
    const setCurrentTest = useSetRecoilState(currentTestState);
    const setDurationState = useSetRecoilState(durationState);
    const setNumberOfQuestions = useSetRecoilState(numberOfQuestionState);
    const setNumberOfRootQuestions = useSetRecoilState(numberOfRootQuestionState);
    const setTestType = useSetRecoilState(testTypeState);
    const setLessonType = useSetRecoilState(lessonTypeState);
    const setRequiredTimeState = useSetRecoilState(requiredTimeState);
    const setRequiredTimeSubmitState = useSetRecoilState(requiredTimeSubmitState);
    const setCurrentQuestionIndexState = useSetRecoilState(currentQuestionIndexState);
    const setNextAbleQuestions = useSetRecoilState(nextAbleQuestionsState);
    const setValueSlide = useSetRecoilState(valueSlideState);
    const [answers, setAnswers] = useRecoilState(answersState);
    const keyCountdownLsg = `timeCountdown${testCode ? `test${testCode}` : `lesson${lessonCode}`}`;
    const timeStorage = localStorage.getItem(keyCountdownLsg);

    useEffect(() => {
        if (answers.length > 0)
            localStorage.setItem(answersStorageKey, JSON.stringify(answers));
    }, [answers]);

    useEffect(() => {
        if (accessToken) {
            getInfo(accessToken);
        }
    }, [uuid, accessToken]);

    useEffect(() => {
        if (getTokenErr != null)
            handleError(getTokenErr, "getTokenErr");
    }, [getTokenErr]);

    const getInfo = (token = '') => {
        if (testCode && isOnline) {
            testService.testInfo(testCode, token)
                .then(response => {
                    handleGetInfoSuccess(response);
                })
                .catch((error) => {
                    handleError(error, "getTestInfo");
                });
        }
        if (lessonCode && isOnline) {
            lessonService.lessonInfo(lessonCode, token)
                .then(response => {
                    handleGetInfoSuccess(response);
                })
                .catch((error) => {
                    handleError(error, "getLessonInfo");
                });
        }
    };

    let loading = false;
    const queryData = (token = '') => {
        if (loading === false && isOnline) {
            loading = true;
            if (testCode) {
                testService.startTest(testCode, token)
                    .then(response => {
                        logService.log("info", "startTest", `testCode: ${testCode}; token: ${token}; `, JSON.stringify(response));
                        handleQueryDataSuccess(response);
                    })
                    .catch((error) => {
                        handleError(error, "queryTestData")
                    });
            }
            if (lessonCode) {
                lessonService.startLesson(lessonCode, token)
                    .then(response => {
                        logService.log("info", "startTest", `lessonCode: ${lessonCode}; token: ${token}; `, JSON.stringify(response));
                        handleQueryDataSuccess(response);
                    })
                    .catch((error) => {
                        handleError(error, "queryLessonData")
                    });
            }
        }
    };

    const handleGetInfoSuccess = (response) => {
        clearOldStateWhenGetInfo();

        let data = response.data;
        setErrorCode("");
        setTestInfo(data);
        setTestType(data.testTypeId);
        setLessonType(data.lessonTypeId);
        setDurationState(data.duration);
        setValueSlide(1);

        if (data.minRequiredTime) {
            setRequiredTimeState(data.minRequiredTime);
            setRequiredTimeSubmitState(false);
        }
    };

    const handleQueryDataSuccess = (response) => {
        loading = false;
        let data = response.data;
        if (data.questions.length === 0) {
            setErrorCode("TEST_NOT_QUESTIONS");
        } else {
            prepareOldData(data);
            // deleteDraftAnswer(data.questions); //delete draft answer in localStorage
            setErrorCode("");
            handleSetCurrentTest(data);
            setTestStatus({"current_status": testStatusNames.TEST_IN_PROGRESS_STATUS});
        }
    };

    const clearOldStateWhenGetInfo = () => {
        setCurrentQuestionIndexState(1);
        setTestStatus({"current_status": testStatusNames.TEST_STARTER_STATUS});
    };

    const prepareOldData = (data) => {
        if (timeStorage) { //có bài làm chưa hoàn thành
            if(localStorage.getItem(answersStorageKey)){
                let storageAnswers = JSON.parse(localStorage.getItem(answersStorageKey));
                setAnswers(storageAnswers);
                setNextAbleQuestions([...new Set(storageAnswers.map(answer => answer.questionCode))]);
            }else {
                setAnswers([]);
                setNextAbleQuestions([]);
            }
        }
        else
        {
            deleteDraftAnswer(data.questions); //delete draft answer in localStorage
        }
    };

    const handleSetCurrentTest = (data) => {
        //Bổ sung ý kiến khác
        data.questions.forEach((question) => {
            if (question.hasOptionalAnswer === 1) {
                question.answers.push({answerCode: `${question.questionCode}_another`, content: i18n.t('your_opinion')})
            }
        });
        setCurrentTest(data);
        setNumberOfQuestions(data.numberOfQuestions);
        setNumberOfRootQuestions(data.questions.length);
    };

    const onStartTest = () => {
        queryData(accessToken);
    };

    //get data test ==> success
    if (testInfo && (testInfo.hasOwnProperty('testCode') || testInfo.hasOwnProperty('lessonCode'))) {
        if (testStatus.current_status === testStatusNames.TEST_STARTER_STATUS) {
            return <WelcomeView testInfo={testInfo} onStartTest={onStartTest}/>;
        } else if (testStatus.current_status === testStatusNames.TEST_IN_PROGRESS_STATUS) {
            return <TestProgressView accessToken={accessToken}/>;
        }
    } else if(!isOnline) {
        return <CustomSweetAlert show={true} text={i18n.t('NO_NETWORK')} showConfirm={false}/>;
    } else{
        return <Loading/>
    }
};

export default withUrlParams(withAuth(withErrorMessage(TestLayout)));
